import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { activateLoading, deactivateLoading } from './GlobalSlice';
import { fetchNatNal, overrideNatNal } from '../APIServices/NatNalService';
import { MockShipmentData } from '../../Helpers/MockData/ShipmentData.mock';
export interface INatNalState {
  driverId: string;
  nextAvailableTime: string;
  nextAvailableLocation: any | null;
  parkLocationRestrictions: any[];
  locationId: string;
  lastLocation: {
    shipmentId: string;
    shipmentAssignmentStopDTO: any | null;
  };
  isEditSection: boolean;
  availableShipment: any[];
}

export const initialState: INatNalState = {
  driverId: '',
  nextAvailableTime: '',
  nextAvailableLocation: null,
  parkLocationRestrictions: [],
  locationId: '',
  lastLocation: {
    shipmentId: '',
    shipmentAssignmentStopDTO: null,
  },
  isEditSection: false,
  availableShipment: [...MockShipmentData],
};

export const NatNalSlice = createSlice({
  name: 'NatNal',
  initialState,
  reducers: {
    resetNatNal: (state) => {
      state = { ...initialState };
    },
    updateIsEditSection: (state, action) => {
      state.isEditSection = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNatNalData.fulfilled, (state, action) => {
      if (action?.payload) {
        state.lastLocation = action?.payload?.lastLocation;
        state.parkLocationRestrictions = action?.payload?.parkLocationRestrictions;
        state.nextAvailableLocation = action?.payload?.nextAvailableLocation;
        state.nextAvailableTime = action?.payload?.nextAvailableTime;
      }
    });
  },
});

export const { resetNatNal, updateIsEditSection } = NatNalSlice.actions;

export default NatNalSlice.reducer;

export const getNatNalData = createAsyncThunk(
  'NatNal/getNatNalData',
  async (payLoad: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchNatNal(payLoad);
    dispatch(deactivateLoading());
    return response;
  },
);

export const overrideNatNalData = createAsyncThunk(
  'NatNal/overrideNatNalData',
  async (payLoad: any) => {
    try {
      const response: any = await overrideNatNal(payLoad);
      return response;
    } catch (error) {
      console.error('Activity : ', error);
      return null;
    }
  },
);
